import { ChartSeries } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/series-v2/index';
import { convertBoolToNumber } from '@src/slide/domain/ui-model/element-modeles/convert/chartConvert';
import _has from 'lodash/has';

export class LineChartSeries extends ChartSeries {
    public static convertDataUiToSdk(uiData) {
        const sdkData = super.convertDataUiToSdk(uiData);
        if (_has(uiData, 'smooth')) {
            sdkData.smooth = convertBoolToNumber(uiData.smooth);
        }

        return sdkData;
    }

    // 是否是平滑线
    public smooth: boolean;
    // 数据点的样式
    constructor(sdkSer, option) {
        super(sdkSer, option);
        const { smooth } = sdkSer;

        // 转成boolean
        this.smooth = !!smooth;
    }
}
